import { http } from '../helpers/http'

const findAll = () => {
  return http.get('/configuration')
}

const update = (data) => {
  const formData = new FormData()
  formData.append('config', data)

  return http.post(
    '/configuration',
    {
      config: data
    },
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

export const configService = {
  findAll,
  update
}
